import {createApi} from "@reduxjs/toolkit/dist/query/react";
import {axiosBaseQuery} from "../index";
import {Consultant, ConsultantDetail, ConsultantListParams, Region} from "../../types";

export const ConsultantApi = createApi({
  reducerPath: 'consultants',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['Consultants'],
  endpoints: (build) => ({
    consultantList: build.query<Consultant[], ConsultantListParams>({
      query: (params) => {
        const searchParams = new URLSearchParams();
        if (params.region_id) searchParams.set('region_id', String(params.region_id));
        if (params.city) searchParams.set('city', params.city);
        if (params.zip) searchParams.set('zip', params.zip);
        const qs = searchParams.toString();
        return {url: `/consultants${qs ? `?${qs}` : ''}`, method: 'get'};
      },
      providesTags: ['Consultants'],
    }),
    consultantDetail: build.query<ConsultantDetail, number>({
      query: (id) => ({url: `/consultants/${id}`, method: 'get'}),
    }),
    regions: build.query<Region[], void>({
      query: () => ({url: '/regions', method: 'get'}),
    }),
  }),
});

export const {
  useConsultantListQuery,
  useConsultantDetailQuery,
  useRegionsQuery,
} = ConsultantApi;
